export enum NotamType {
  N = "N",
  R = "R",
  C = "C",
}
